import { useTranslation } from "react-i18next";
import { Icon } from "@/components/icon";
import { useSettingActions, useSettings } from "@/store/settingStore";
import { Button } from "@/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/ui/dropdown-menu";
import { COMMON_TIME_ZONE_OPTIONS, DEFAULT_TIME_ZONE, getTimeZoneOffsetLabel } from "@/utils/time-zone";

export default function TimeZonePicker() {
  const { t } = useTranslation();
  const settings = useSettings();
  const { setSettings } = useSettingActions();
  const timeZone = settings.timeZone || DEFAULT_TIME_ZONE;

  const setTimeZone = (nextTimeZone: string) => {
    setSettings({
      ...settings,
      timeZone: nextTimeZone,
    });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="rounded-full" aria-label={t("common.time_zone.aria_label")}>
          <Icon icon="tabler:timezone" size={18} />
          {timeZone}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuRadioGroup value={timeZone} onValueChange={setTimeZone}>
          {COMMON_TIME_ZONE_OPTIONS.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              <span className="min-w-0 flex-1 truncate">{option.label}</span>
              <span className="text-xs text-muted-foreground">{getTimeZoneOffsetLabel(option.value)}</span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
